import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React, { useRef, useState } from "react";
import { SettlementRowObj } from "..";
import { MdDelete, MdHighlightOff, MdWarning } from "react-icons/md";
import Searchbox from "components/fields/Searchbox";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { IoEye } from "react-icons/io5";
import Pagination from "components/pagination";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalOverlay, ModalHeader, ModalFooter } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import CrerateSettlementReport from "./CrerateSettlementReport";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import { getProfileSecond } from "api/graphQL_users";
import InputField from "components/fields/InputField";
import { Link } from "react-router-dom";
import { deleteAPIAccessToken, verifyBackOfficeAPI } from "api/api_access";
import CrerateAPIAccessFilter from "./CrerateAPIAccessFilter";
import { RiArrowUpDownFill } from "react-icons/ri";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const columnHelper = createColumnHelper<SettlementRowObj>();

function SettlementTable(props: {
  tableData: any;
  fetchAllsettlement: () => void;
  isLoading: boolean;
  page: number;
  setPage: any;
  totalpage: number;
  totalItems: number;
  currentPage: number;
  pageSize: number;
  setPageSize: any;
  roleData: any;
  timeZone: any;
  allCardType: any;
  onValueChange: (value: string) => void;
  allOrgDetails: any;
}) {
  const {
    tableData, fetchAllsettlement, page, setPage, currentPage,
    totalpage, totalItems, pageSize, setPageSize, roleData, onValueChange, allOrgDetails,
  } = props;

  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  const [isOpenDelete, setIsopenDelete] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [DeleteRowId, setDeleteRowId] = useState("");
  const [isOpen2FAPopup, setIsOpen2FAPopup] = useState<boolean>(false);
  const [TwoFaLoading, setTwoFaLoading] = useState(false);
  const [userVerificationData, setUserVerificationData] = useState<any>({});
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [isCloseModal2fa, setIsCloseModal2fa] = useState<boolean>(false);
  const [authCode, setAuthCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>(new Array(6).fill(null));

  React.useEffect(() => { setData(tableData ?? []); }, [tableData]);

  const isTokenExpired = (expiryDate: any) => {
    if (!expiryDate) return false;
    const date = new Date(expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date.getTime() <= today.getTime();
  };

  const handleDeleteClose = () => {
    setDeleteRowId("");
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); setIsopenDelete(false); }, 300);
  };

  const onClose2FAPopup = () => {
    setIsOpen2FAPopup(false);
    setAuthCode(["", "", "", "", "", ""]);
    setUserVerificationData({});
    setIsCloseModal2fa(true);
    setTimeout(() => setIsCloseModal2fa(false), 300);
  };

  const deleteAPIToken = () => {
    setIsDeleteLoading(true);
    deleteAPIAccessToken(DeleteRowId)
      .then(() => { setIsDeleteLoading(false); toast.success("Record deleted successfully!"); fetchAllsettlement(); handleDeleteClose(); })
      .catch(() => setIsDeleteLoading(false));
  };

  const verify2FA = () => {
    setTwoFaLoading(true);
    const passcode = authCode.join("");
    if (!userVerificationData?.password) { setTwoFaLoading(false); toast.error("Please enter password"); return; }
    if (userVerificationData.password.length < 8) { setTwoFaLoading(false); toast.error("Password must be at least 8 characters"); return; }
    if (!passcode || passcode.length < 6) { setTwoFaLoading(false); toast.error("Please enter valid 2FA code"); return; }

    verifyBackOfficeAPI({ password: userVerificationData.password, otp: passcode, backoffice_access_token_id: userVerificationData.backoffice_access_token_id })
      .then((res) => {
        setData((prev: any) => prev.map((t: any) => t.id === res?.id ? { ...t, token: res.token, is_verified: res.is_verified } : t));
        toast.success(res?.message);
        onClose2FAPopup();
        setTwoFaLoading(false);
      })
      .catch((error) => { setTwoFaLoading(false); toast.error(error?.response?.data?.message ?? "Something went wrong!"); });
  };

  const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newCode = [...authCode]; newCode[index] = value; setAuthCode(newCode);
      if (value && index < 5) inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !authCode[index] && index > 0) inputRefs.current[index - 1]?.focus();
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) { setAuthCode(pastedData.split("")); inputRefs.current[5]?.focus(); }
  };

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      header: () => <span className="apt-th">Token Name</span>,
      cell: (info: any) => (
        <div className="apt-name-cell">
          <div className="apt-token-avatar">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <div className="apt-name-wrapper">
            <span className="apt-name">{info.row.original?.name}</span>
            <span className="apt-created">{info.row.original?.created_at.replace("GMT","")}</span>
          </div>
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.name || "";
        const b = rowB.original.name || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
      enableSorting: true,
    }),
    columnHelper.accessor("id", {
      id: "token_col",
      header: () => <span className="apt-th">Private Token</span>,
      cell: (info: any) => {
        const expired = isTokenExpired(info.row.original?.expiry_date);
        return (
          <div className="apt-token-cell">
            {info.row.original?.token ? (
              <ShortTruncateCopy info={info.row.original?.token} showCopy={true} />
            ) : (
              <div className="apt-token-hidden">
                <span className="apt-token-mask">••••••••••</span>
                {!expired && (
                  <button
                    className="apt-eye-btn"
                    onClick={() => {
                      getProfileSecond()
                        .then((data) => {
                          setIsOpen2FAPopup(true);
                          setUserVerificationData((prev: any) => ({ ...prev, backoffice_access_token_id: info.row.original?.id, is_auth_2fa_activate: data[0]?.auth_2fa }));
                        })
                        .catch(() => toast.error("Something went wrong!"));
                    }}
                  >
                    <IoEye size={15} />
                  </button>
                )}
              </div>
            )}
          </div>
        );
      },
      enableSorting: false,
    }),
    columnHelper.accessor("expiry_date", {
      id: "expiry_date",
      header: () => <span className="apt-th">Expiry</span>,
      cell: (info: any) => (
        <span className="apt-date">
          {info.row.original?.expiry_date
            ? info.row.original.expiry_date.replace("GMT", "")
            : "—"}
        </span>
      ),
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.expiry_date || "";
        const b = rowB.original.expiry_date || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
      enableSorting: true,
    }),
    columnHelper.accessor("api_hit_limit", {
      id: "api_hit_limit",
      header: () => <span className="apt-th">API Limit</span>,
      cell: (info: any) => (
        <span className="apt-limit">{info.row.original?.api_hit_limit || "—"}</span>
      ),
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.api_hit_limit || "";
        const b = rowB.original.api_hit_limit || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: () => <span className="apt-th">Status</span>,
      cell: (info: any) => {
        const expired = isTokenExpired(info.row.original?.expiry_date);
        const status = info.row.original?.status;
        if (expired) return <span className="apt-badge apt-badge--expired">Expired</span>;
        if (status === "ACTIVE") return <span className="apt-badge apt-badge--active">Active</span>;
        if (status === "BLOCK") return <span className="apt-badge apt-badge--blocked">Blocked</span>;
        return <span className="apt-badge apt-badge--none">—</span>;
      },
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.status || "";
        const b = rowB.original.status || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    columnHelper.accessor("id", {
      id: "actions",
      header: () => <span className="apt-th">Actions</span>,
      cell: (info: any) => {
        const expired = isTokenExpired(info.row.original?.expiry_date);
        return (
          <div className="apt-actions">
            {roleData?.[0]?.api?.value?.view_api && (
              <CrerateSettlementReport fetchAllsettlement={fetchAllsettlement} allOrgDetails={allOrgDetails} roleData={roleData} isInfo={true} info={info} />
            )}
            {roleData?.[0]?.api?.value?.edit_api && !expired && (
              <CrerateSettlementReport fetchAllsettlement={fetchAllsettlement} allOrgDetails={allOrgDetails} roleData={roleData} isInfo={false} info={info} />
            )}
            {roleData?.[0]?.api?.value?.view_history_api && (
              <CrerateAPIAccessFilter fetchAllsettlement={fetchAllsettlement} roleData={roleData} info={info} />
            )}
            {roleData?.[0]?.api?.value?.delete_api && (
              <Popover trigger="hover" placement="bottom">
                <PopoverTrigger>
                  <button className="apt-del-btn" onClick={() => { setIsopenDelete(true); setDeleteRowId(info.row.original?.id); }} aria-label="Delete">
                    <MdDelete size={15} />
                  </button>
                </PopoverTrigger>
                <PopoverContent border="1px solid #fecaca" borderRadius="12px" bg="#fef2f2" maxW="180px" p="0" overflow="hidden" zIndex="20">
                  <PopoverHeader bg="#fee2e2" fontSize="12px" fontWeight="700" color="#b91c1c" borderBottom="1px solid #fecaca" px="12px" py="9px">Delete Token</PopoverHeader>
                  <PopoverArrow bg="#fef2f2" />
                </PopoverContent>
              </Popover>
            )}
          </div>
        );
      },
      enableSorting: false,
    }),
  ];

  const columnsNonAction = columns.slice(0, 5);
  const hasActionPerms = roleData?.[0]?.api?.value?.view_api || roleData?.[0]?.api?.value?.delete_api || roleData?.[0]?.api?.value?.edit_api || roleData?.[0]?.api?.value?.view_history_api;

  const table = useReactTable({
    data,
    columns: hasActionPerms ? columns : columnsNonAction,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="apt-card">
      {/* Header */}
      <div className="apt-header">
        <div className="apt-header-left">
          <div className="apt-header-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <div>
            <h3 className="apt-title">API Tokens</h3>
            <p className="apt-subtitle">{totalItems > 0 ? `${totalItems} total token${totalItems !== 1 ? "s" : ""}` : "No tokens found"}</p>
          </div>
        </div>
        <div className="apt-search-wrap">
          <Searchbox onSearch={(e) => { onValueChange(e); }} />
        </div>
      </div>

      {/* Table */}
      <div className="apt-table-wrap">
        {props.isLoading ? (
          <div className="apt-loading"><div className="apt-spinner"/><p className="apt-loading-txt">Loading tokens…</p></div>
        ) : (
          <table className="apt-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan} onClick={h.column.getCanSort() ? h.column.getToggleSortingHandler() : undefined} className={`apt-thead-th${h.column.getCanSort() ? " apt-thead-th--sort" : ""}`}>
                      <div className="apt-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="apt-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11}/> : h.column.getIsSorted() === "desc" ? <BsArrowDown size={11}/> : <RiArrowUpDownFill size={11}/>}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <tr key={row.id} className={`apt-tbody-tr${ri % 2 !== 0 ? " apt-tbody-tr--alt" : ""}`}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="apt-tbody-td">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr><td colSpan={10}>
                  <div className="apt-empty">
                    <div className="apt-empty-icon">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                    </div>
                    <p className="apt-empty-title">No tokens found</p>
                    <p className="apt-empty-sub">Create your first API token to get started</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="apt-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      {/* ── Delete confirmation panel ── */}
      <Modal isOpen={isOpenDelete} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`apt-del-panel${isOpenDelete && !isCloseModal ? " apt-del-panel--open" : " apt-del-panel--close"}`}>
          <div className="apt-del-header">
            <div className="apt-del-header-left">
              <div className="apt-del-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
              </div>
              <div>
                <h2 className="apt-del-title">Delete Token</h2>
                <p className="apt-del-sub">This action cannot be undone</p>
              </div>
            </div>
            <button className="apt-del-close" onClick={handleDeleteClose}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div className="apt-del-body">
            <div className="apt-del-warning">
              <div className="apt-del-warning-icon"><MdWarning size={22}/></div>
              <div>
                <p className="apt-del-warning-title">Irreversible Action</p>
                <p className="apt-del-warning-desc">This API token will be permanently deleted. Any integrations using it will stop working immediately.</p>
              </div>
            </div>
          </div>
          <div className="apt-del-footer">
            <button className="apt-btn-cancel" onClick={handleDeleteClose}>Cancel</button>
            <button className="apt-btn-delete" onClick={deleteAPIToken} disabled={isDeleteLoading}>
              {isDeleteLoading ? <span className="apt-spinner-sm"/> : (
                <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>Delete Token</>
              )}
            </button>
          </div>
        </div>
      </Modal>

      {/* ── 2FA Verification panel ── */}
      <Modal isOpen={isOpen2FAPopup} onClose={onClose2FAPopup}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`apt-2fa-panel${isOpen2FAPopup && !isCloseModal2fa ? " apt-2fa-panel--open" : " apt-2fa-panel--close"}`}>
          <div className="apt-2fa-header">
            <div className="apt-del-header-left">
              <div className="apt-2fa-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div>
                <h2 className="apt-del-title">2FA Verification</h2>
                <p className="apt-del-sub">Verify your identity to reveal the token</p>
              </div>
            </div>
            <button className="apt-del-close" onClick={onClose2FAPopup}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div className="apt-2fa-body">
            {!userVerificationData?.is_auth_2fa_activate ? (
              <div className="apt-2fa-no-2fa">
                <div className="apt-2fa-no-2fa-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                </div>
                <p className="apt-2fa-no-2fa-title">2FA Not Activated</p>
                <p className="apt-2fa-no-2fa-desc">To view this token, you need to activate 2FA on your account. Visit <Link to="/admin/profile" className="apt-link">profile settings</Link> to enable it.</p>
              </div>
            ) : (
              <>
                <p className="apt-2fa-hint">Enter your password and 2FA code to reveal the token.</p>
                <div className="apt-field-wrap">
                  <label className="apt-label">Password <span className="apt-req">*</span></label>
                  <InputField
                    variant="auth" extra="w-full" label="" placeholder="Enter password"
                    id="password" type={userVerificationData?.isShow ? "text" : "password"}
                    value={userVerificationData?.password}
                    onChange={(e: any) => setUserVerificationData((p: any) => ({ ...p, [e.target.id]: e.target.value }))}
                    passwordShow={userVerificationData?.isShow}
                    setPasswordShow={() => setUserVerificationData((p: any) => ({ ...p, isShow: !p?.isShow }))}
                  />
                </div>
                <div className="apt-field-wrap">
                  <label className="apt-label">2FA Code <span className="apt-req">*</span></label>
                  <div className="si-otp-group">
                    {authCode.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={index === 0 ? handlePaste : undefined}
                        className={`si-otp-inp${digit ? " si-otp-inp--filled" : ""}`}
                        aria-label={`Digit ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="apt-del-footer">
            <button className="apt-btn-cancel" onClick={onClose2FAPopup}>Cancel</button>
            {userVerificationData?.is_auth_2fa_activate && (
              <button className="apt-btn-verify" onClick={verify2FA} disabled={TwoFaLoading}>
                {TwoFaLoading ? <span className="apt-spinner-sm"/> : (
                  <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Verify</>
                )}
              </button>
            )}
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .apt-card {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #fff; border: 1px solid #e2e8f0; border-radius: 18px;
          overflow: hidden; box-shadow: 0 2px 8px rgba(15,23,42,0.06);
        }
        .apt-header {
          padding: 20px 24px 16px; border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap;
        }
        .apt-header-left { display: flex; align-items: center; gap: 12px; }
        .apt-header-icon {
          width: 40px; height: 40px; border-radius: 11px;
          background: linear-gradient(135deg,#fffbeb,#fef3c7); border: 1.5px solid #fde68a;
          display: flex; align-items: center; justify-content: center; color: #d97706; flex-shrink: 0;
        }
        .apt-title { font-size: 15px; font-weight: 700; color: #0f172a; letter-spacing: -0.2px; margin-bottom: 2px; line-height: 22px; }
        .apt-subtitle { font-size: 12px; color: #94a3b8; font-weight: 500; }
        .apt-search-wrap { min-width: 220px; }

        .apt-table-wrap { overflow-x: auto; }
        .apt-table-wrap::-webkit-scrollbar { height: 4px; }
        .apt-table-wrap::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .apt-table { width: 100%; border-collapse: collapse; }

        .apt-thead-th { padding: 12px 16px 10px; background: #f8fafc; border-bottom: 1.5px solid #e2e8f0; text-align: left; white-space: nowrap; user-select: none; }
        .apt-thead-th--sort { cursor: pointer; }
        .apt-thead-th--sort:hover { background: #f1f5f9; }
        .apt-th-inner { display: flex; align-items: center; gap: 5px; }
        .apt-th { font-size: 11.5px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 0.5px; }
        .apt-sort-icon { color: #94a3b8; display: flex; align-items: center; }
        .apt-thead-th--sort:hover .apt-sort-icon { color: #d97706; }

        .apt-tbody-tr { transition: background .12s; }
        .apt-tbody-tr:hover { background: #f8fafc; }
        .apt-tbody-tr--alt { background: #fafbfc; }
        .apt-tbody-tr--alt:hover { background: #f1f5f9; }
        .apt-tbody-td { padding: 13px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }

        .apt-name-cell { display: flex; align-items: center; gap: 10px; }
        .apt-token-avatar {
          width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
          background: linear-gradient(135deg,#fffbeb,#fef3c7); border: 1.5px solid #fde68a;
          display: flex; align-items: center; justify-content: center; color: #d97706;
        }
        .apt-name-wrapper { display: flex; flex-direction: column; gap: 2px; }
        .apt-name { font-size: 13px; font-weight: 700; color: #0f172a; white-space: nowrap; }
        .apt-created { font-size: 11px; color: #94a3b8; font-weight: 500; }
        .apt-date, .apt-limit { font-size: 13px; font-weight: 500; color: #475569; }

        .apt-token-cell { display: flex; align-items: center; }
        .apt-token-hidden { display: flex; align-items: center; gap: 8px; }
        .apt-token-mask { font-size: 13px; color: #94a3b8; font-weight: 600; letter-spacing: 2px; }
        .apt-eye-btn {
          display: flex; align-items: center; justify-content: center;
          width: 28px; height: 28px; border-radius: 7px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; color: #64748b;
          cursor: pointer; transition: all .15s;
        }
        .apt-eye-btn:hover { background: #fffbeb; border-color: #fde68a; color: #d97706; }

        .apt-badge {
          display: inline-flex; align-items: center;
          padding: 4px 10px; border-radius: 7px;
          font-size: 11.5px; font-weight: 700; white-space: nowrap;
        }
        .apt-badge--active { background: linear-gradient(135deg,#f0fdf4,#dcfce7); border: 1.5px solid #bbf7d0; color: #15803d; }
        .apt-badge--blocked { background: linear-gradient(135deg,#fff1f2,#ffe4e6); border: 1.5px solid #fecdd3; color: #e11d48; }
        .apt-badge--expired { background: #f8fafc; border: 1.5px solid #e2e8f0; color: #94a3b8; }
        .apt-badge--none { color: #94a3b8; }

        .apt-actions { display: flex; align-items: center; gap: 6px; }
        .apt-del-btn {
          width: 30px; height: 30px; border-radius: 8px;
          background: #fff7f7; border: 1.5px solid #fecaca; color: #dc2626;
          cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all .15s;
        }
        .apt-del-btn:hover { background: #fee2e2; border-color: #fca5a5; }

        .apt-empty {
          display: flex; flex-direction: column; align-items: center;
          justify-content: center; padding: 56px 24px; gap: 10px;
        }
        .apt-empty-icon {
          width: 52px; height: 52px; border-radius: 13px;
          background: #f8fafc; border: 1.5px solid #e2e8f0;
          display: flex; align-items: center; justify-content: center; color: #cbd5e1;
        }
        .apt-empty-title { font-size: 14px; font-weight: 700; color: #64748b; }
        .apt-empty-sub { font-size: 12.5px; color: #94a3b8; font-weight: 500; text-align: center; }

        .apt-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 56px; gap: 12px; }
        .apt-spinner {
          width: 28px; height: 28px; border: 3px solid #e2e8f0; border-top-color: #d97706;
          border-radius: 50%; animation: aptSpin .7s linear infinite;
        }
        @keyframes aptSpin { to { transform: rotate(360deg); } }
        .apt-loading-txt { font-size: 13px; color: #94a3b8; font-weight: 500; }
        .apt-pagination-wrap { padding: 12px 16px; border-top: 1px solid #f1f5f9; background: #fafbfc; }

        /* ── Slide panels ── */
        .apt-del-panel, .apt-2fa-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 520px;
          background: #fff; z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -8px 0 40px rgba(15,23,42,0.15);
          transition: transform .32s cubic-bezier(0.16,1,0.3,1);
        }
        .apt-del-panel--open, .apt-2fa-panel--open { transform: translateX(0); }
        .apt-del-panel--close, .apt-2fa-panel--close { transform: translateX(100%); }

        .apt-del-header, .apt-2fa-header {
          padding: 16.5px 28px;
          background: linear-gradient(135deg,#7f1d1d,#dc2626);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .apt-2fa-header { background: linear-gradient(135deg,#1e3a8a,#1d4ed8); }
        .apt-del-header-left { display: flex; align-items: center; gap: 14px; }
        .apt-del-icon, .apt-2fa-icon {
          width: 42px; height: 42px; border-radius: 11px;
          background: rgba(255,255,255,.18); border: 1.5px solid rgba(255,255,255,.28);
          display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0;
        }
        .apt-del-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 22px; }
        .apt-del-sub { font-size: 12.5px; color: rgba(255,255,255,.65); font-weight: 500; }
        .apt-del-close {
          background: rgba(255,255,255,.15); border: none; border-radius: 8px;
          width: 32px; height: 32px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: rgba(255,255,255,.8); transition: background .15s;
        }
        .apt-del-close:hover { background: rgba(255,255,255,.25); }

        .apt-del-body, .apt-2fa-body { flex: 1; padding: 28px; overflow-y: auto; display: flex; flex-direction: column; gap: 18px; }
        .apt-del-warning {
          display: flex; gap: 14px;
          background: linear-gradient(135deg,#fff7f7,#fee2e2);
          border: 1.5px solid #fecaca; border-radius: 14px; padding: 18px;
        }
        .apt-del-warning-icon {
          width: 44px; height: 44px; border-radius: 11px;
          background: #fff; border: 1.5px solid #fecaca;
          display: flex; align-items: center; justify-content: center; color: #dc2626; flex-shrink: 0;
        }
        .apt-del-warning-title { font-size: 14px; font-weight: 700; color: #991b1b; margin-bottom: 6px; }
        .apt-del-warning-desc { font-size: 13px; color: #b91c1c; line-height: 1.55; font-weight: 500; }

        .apt-del-footer {
          padding: 14px 28px; border-top: 1px solid #f1f5f9; background: #fafbfc;
          display: flex; align-items: center; justify-content: flex-end;
          gap: 10px; flex-shrink: 0;
        }
        .apt-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #64748b;
          padding: 10px 20px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all .15s;
        }
        .apt-btn-cancel:hover { background: #f1f5f9; color: #374151; }
        .apt-btn-delete {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg,#991b1b,#dc2626);
          cursor: pointer; box-shadow: 0 4px 14px rgba(220,38,38,.28); transition: all .15s;
        }
        .apt-btn-delete:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(220,38,38,.36); }
        .apt-btn-delete:disabled { opacity: .5; cursor: not-allowed; transform: none; }
        .apt-btn-verify {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg,#1d4ed8,#2563eb);
          cursor: pointer; box-shadow: 0 4px 14px rgba(37,99,235,.28); transition: all .15s;
        }
        .apt-btn-verify:hover { transform: translateY(-1px); }
        .apt-btn-verify:disabled { opacity: .5; cursor: not-allowed; transform: none; }

        .apt-spinner-sm { display: inline-block; width: 14px; height: 14px; border: 2px solid rgba(255,255,255,.35); border-top-color: #fff; border-radius: 50%; animation: aptSpin .65s linear infinite; }

        /* 2FA specific */
        .apt-2fa-no-2fa {
          display: flex; flex-direction: column; align-items: center; gap: 12px; text-align: center; padding: 20px 0;
        }
        .apt-2fa-no-2fa-icon {
          width: 52px; height: 52px; border-radius: 13px;
          background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center; color: #2563eb;
        }
        .apt-2fa-no-2fa-title { font-size: 15px; font-weight: 700; color: #0f172a; }
        .apt-2fa-no-2fa-desc { font-size: 13px; color: #64748b; font-weight: 500; line-height: 1.6; }
        .apt-link { color: #2563eb; font-weight: 700; }
        .apt-2fa-hint { font-size: 13px; color: #64748b; font-weight: 500; line-height: 1.5; }
        .apt-field-wrap { display: flex; flex-direction: column; gap: 6px; }
        .apt-label { font-size: 12.5px; font-weight: 700; color: #374151; }
        .apt-req { color: #dc2626; }
        .si-otp-group { display: flex; justify-content: flex-start; gap: 10px; }
        .si-otp-inp {
          width: 54px; height: 62px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 14px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 24px; font-weight: 700;
          color: #0f172a; text-align: center; outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none; caret-color: #2563eb;
        }
        .si-otp-inp:focus {
          border-color: #2563eb; background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .si-otp-inp--filled {
          border-color: #93c5fd; background: #eff6ff; color: #1d4ed8;
        }
        @media (max-width: 600px) {
          .si-otp-group { gap: 8px; }
          .si-otp-inp { width: 46px; height: 54px; font-size: 20px; border-radius: 12px; }
        }
        @media (max-width: 380px) {
          .si-otp-inp { width: 40px; height: 48px; font-size: 18px; border-radius: 10px; }
          .si-otp-group { gap: 6px; }
        }

        @media (max-width: 700px) {
          .apt-header { flex-direction: column; align-items: flex-start; }
          .apt-search-wrap { width: 100%; }
          .apt-del-panel, .apt-2fa-panel { max-width: 100%; }
        }
      `}</style>
    </div>
  );
}

export default SettlementTable;